// Based on: https://stackoverflow.com/a/52433715
/**
 * Maps TS enums with numbers as values to an array of its keys
 *
 * Detailed explanation:
 *
 * enum MyEnum {
 *   Part1 = 0,
 *   Part2 = 1
 * }
 *
 * will be emitted by TS as
 * {
 *   Part1: 0,
 *   Part2: 1,
 *   0: 'Part1',
 *   1: 'Part2'
 * }
 *
 * Thus it's enough to take the number values
 */
// TODO: verify this wording makes sense
export function enumWithNumberValuesToArrayOfKeys(someEnum) {
    return Object.keys(someEnum)
        .filter((p) => typeof someEnum[p] === 'number')
        .map((p) => someEnum[p]);
}
/**
 * Maps TS enums with strings as values to an array of its keys
 *
 * Detailed explanation:
 *
 * enum MyEnum {
 *   Part1 = "Value of Part1",
 *   Part2 = "Value of Part2"
 * }
 *
 * will be emitted by TS as
 * {
 *   Part1: "Value of Part1",
 *   Part2: "Value of Part2",
 * }
 *
 */
export function enumWithStringValuesToArrayOfKeys(someEnum) {
    return Object.keys(someEnum)
        .filter((p) => typeof someEnum[p] === 'string')
        .map((p) => someEnum[p]);
}
